<template>
<div class='container-center-horizontal-melody'>
    <span class='colortitle-sing title tamanhotitle'>{{$t('games.melody.gamemode')}}</span>
    <div class='button-list-gamemode animated-choosegamelist'>
        <div class='space-gamemode '>
            <span class='fig-gamemode'
            :class="{ 'sel-gamemode-sing' : selected == 'Spain' }"
            @click="onClick('Spain')">
                <img :src="require('@/assets/gamemode/es.svg')">
                <span class="mode colortext-sing tamanho0">{{$t('games.shared.gamemodes.spain')}}</span>
            </span>

            <span class='fig-gamemode gamemode-2'
            :class="{ 'sel-gamemode-sing' : selected == 'Italy' }"
            @click="onClick('Italy')">
                <img :src="require('@/assets/gamemode/it.svg')">
                <span class="mode colortext-sing tamanho0">{{$t('games.shared.gamemodes.italy')}}</span>
            </span>

            <span class='fig-gamemode gamemode-3'
            :class="{ 'sel-gamemode-sing' : selected == 'Portugal' }"
            @click="onClick('Portugal')">
                <img :src="require('@/assets/gamemode/pt.svg')">
                <span class="mode colortext-sing tamanho0">{{$t('games.shared.gamemodes.portugal')}}</span>
            </span>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: "ChooseGameMode",
    emits: ['chooseGM'],
    data() {
        return {
            selected: ''
        }
    },
    methods: {
        onClick(num) {
            this.selected = num;
            this.$emit('chooseGM', num);
        }
    }
};
</script>

<style>
.colortitle-sing{
    color: white;
}

.colortext-sing{
    color:#283583;
}
.color-sing{
    color:#009FE3;
}
.sel-gamemode-sing {
    box-shadow: 0 0 0 7px #009FE3;
}

@media only screen and (max-width: 480px) {

    .sel-gamemode-sing {
        box-shadow: 0 0 0 3px #009FE3;
    }

}
@media only screen and (min-width: 480px) and (max-width: 550px) {

    .sel-gamemode-sing {
        box-shadow: 0 0 0 4px #009FE3;
    }

}

@media only screen and (min-width: 550px) and (max-width: 630px){

    .sel-gamemode-sing {
        box-shadow: 0 0 0 5px #009FE3;
    }

}
@media only screen and (min-width: 630px) and (max-width: 718px){

    .sel-gamemode-sing {
        box-shadow: 0 0 0 6px #009FE3;
    }

}
@media only screen and (min-width: 718px) and (max-width: 806px) {

    .sel-gamemode-sing {
        box-shadow: 0 0 0 7px #009FE3;
    }
}
@media only screen and (min-width: 806px) and (max-width: 1024px) {

    .sel-gamemode-sing {
        box-shadow: 0 0 0 8px #009FE3;
    }

}
@media only screen and (min-width: 1024px) and (max-width: 1200px) {

    .sel-gamemode-sing {
        box-shadow: 0 0 0 9px #009FE3;
    }

}
@media only screen and (min-width: 1200px) and (max-width: 1366px) {

    .sel-gamemode-sing {
        box-shadow: 0 0 0 10px #009FE3;
    }

}
@media only screen and (min-width: 1366px) and (max-width: 1540px){

    .sel-gamemode-sing {
        box-shadow: 0 0 0 11px #009FE3;
    }
}
@media only screen and (min-width: 1540px) and (max-width: 1680px){

    .sel-gamemode-sing {
        box-shadow: 0 0 0 12px #009FE3;
    }
}
@media only screen and (min-width: 1680px) and (max-width:2350px){
    .sel-gamemode-sing {
        box-shadow: 0 0 0 13px #009FE3;
    }
}
@media only screen and (min-width: 2350px) {
    .sel-gamemode-sing {
        box-shadow: 0 0 0 14px #009FE3;
    }
}
</style>
